import React, { useState, useEffect, useRef } from "react";
import { IconSymbol } from "@abyss/web/ui/IconSymbol";

import classNames from "classnames";

import styles from "./votebuttons.module.css";

export const VoteButtons = () => {
  const [upVote, setUpVote] = useState(false);
  const [downVote, setDownVote] = useState(false);
  const [openAccordion, setOpenAccordion] = useState(false);

  const toggleAccordion = () => {
    setOpenAccordion(!openAccordion);
  };

  return (
    <div>
      <div className={styles.voteButtons}>
        <div
          onClick={() => {
            setUpVote(true);
            setDownVote(false);
          }}
        >
          <IconSymbol
            icon="thumb_up"
            size="16px"
            color={upVote === false ? "#4B4D4F" : "#196ECF"}
            variant={upVote === false ? "outlined" : "filled"}
          />
        </div>
        <div
          onClick={() => {
            setUpVote(false);
            setDownVote(true);
          }}
        >
          <IconSymbol
            icon="thumb_down"
            size="16px"
            color={downVote === false ? "#4B4D4F" : "#196ECF"}
            variant={downVote === false ? "outlined" : "filled"}
          />
        </div>
      </div>

      <div className={styles.sources}>
        <div
          className={classNames(
            styles.sourcesButton,
            openAccordion ? styles.open : ""
          )}
          onClick={toggleAccordion}
        >
          <span>Sources (4)</span>
          <IconSymbol icon="expand_more" />
        </div>
        <ul
          className={classNames(
            styles.sourcesDrop,
            openAccordion ? styles.open : ""
          )}
        >
          <li>
            <span>
              <span>
                <IconSymbol icon="picture_as_pdf" variant="outlined" />
              </span>
              <span>MN-0005 2025 EOC: 2.1</span>
            </span>
          </li>
          <li>
            <span>
              <span>
                <IconSymbol icon="picture_as_pdf" variant="outlined" />
              </span>
              <span>MN-0005 2025 EOC: 2.1: 106</span>
            </span>
          </li>
          <li>
            <span>
              <span>
                <IconSymbol icon="picture_as_pdf" variant="outlined" />
              </span>
              <span>MN-0005 2025 SB</span>
            </span>
          </li>
          <li>
            <span>
              <span>
                <IconSymbol icon="picture_as_pdf" variant="outlined" />
              </span>
              <span>MN-0005 2025 EOC: 2.1: 105</span>
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};
